import { StateCreator } from 'zustand';
import { isEqual } from 'lodash';

export interface PollingSlice {
    inProgress: ImportExportAPIResponse[];
    completed: ImportExportAPIResponse[];
    pollingInProgress: boolean;
    setPollingInProgress: (value: boolean) => void;
    setPollingData: (inProgress: ImportExportAPIResponse[], completed: ImportExportAPIResponse[]) => void;
}

export const createPollingSlice: StateCreator<PollingSlice, [], [], PollingSlice> = (set) => ({
    inProgress: [],
    completed: [],
    pollingInProgress: false,
    setPollingInProgress: (value) => set(() => ({ pollingInProgress: value })),
    setPollingData: (inProgress: ImportExportAPIResponse[], completed: ImportExportAPIResponse[]) => {
        set((state) => {
            const inProgressChanged = !isEqual(state.inProgress, inProgress);
            const completedChanged = !isEqual(state.completed, completed);
            if (inProgressChanged || completedChanged) {
                return { inProgress, completed };
            }
            return state;
        });
    }
});
